import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "alert alert-danger mb-5"
}
const _hoisted_2 = {
  key: 0,
  class: "card-header border-0 pt-5"
}
const _hoisted_3 = { class: "card-title align-items-center" }
const _hoisted_4 = { class: "svg-icon svg-icon-2 me-2 text-primary" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "card-label fw-bold fs-3" }, "Knowledge Bases", -1)
const _hoisted_6 = { class: "card-toolbar" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex justify-content-end mb-4"
}
const _hoisted_8 = { class: "alert alert-primary d-flex align-items-center mb-5" }
const _hoisted_9 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("strong", null, "Knowledge Bases & AI Auto-Replies:", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" You can feed your AI agent documents and website links so it instantly has the right information to answer customer questions on Facebook Messenger and other channels. Note that this is separate from the ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Leader's Toolkit")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(", which holds team presentations and creatives. ")
const _hoisted_14 = { class: "d-flex flex-wrap flex-stack mb-4" }
const _hoisted_15 = { class: "text-muted fs-7" }
const _hoisted_16 = {
  key: 1,
  class: "text-center py-10 text-muted"
}
const _hoisted_17 = { class: "text-muted fw-semibold mb-4" }
const _hoisted_18 = { class: "row g-4" }
const _hoisted_19 = { class: "card h-100 border hover-elevate-up" }
const _hoisted_20 = { class: "card-body d-flex flex-column" }
const _hoisted_21 = { class: "d-flex align-items-start justify-content-between gap-2 mb-2" }
const _hoisted_22 = { class: "fs-5 fw-bold mb-0" }
const _hoisted_23 = {
  key: 0,
  class: "badge badge-light-info"
}
const _hoisted_24 = {
  key: 1,
  class: "badge badge-light-success"
}
const _hoisted_25 = {
  key: 0,
  class: "text-muted fs-7 mb-4"
}
const _hoisted_26 = { class: "mt-auto d-flex flex-wrap gap-2" }
const _hoisted_27 = {
  key: 0,
  class: "card-header border-0 pt-5"
}
const _hoisted_28 = { class: "card-title align-items-center" }
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left" }, null, -1)
const _hoisted_30 = { class: "card-label fw-bold fs-3" }
const _hoisted_31 = {
  key: 0,
  class: "badge badge-light ms-3"
}
const _hoisted_32 = {
  key: 0,
  class: "d-flex align-items-center gap-2 mb-4"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-left" }, null, -1)
const _hoisted_34 = { class: "fw-bold fs-5" }
const _hoisted_35 = {
  key: 0,
  class: "badge badge-light"
}
const _hoisted_36 = {
  key: 1,
  class: "d-flex flex-wrap gap-2 mb-6"
}
const _hoisted_37 = { class: "btn btn-sm btn-light-primary mb-0" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Upload File ")
const _hoisted_39 = {
  key: 2,
  class: "alert alert-info mb-5"
}
const _hoisted_40 = {
  "aria-label": "breadcrumb",
  class: "mb-4"
}
const _hoisted_41 = { class: "breadcrumb breadcrumb-line text-muted fs-6 fw-bold mb-0" }
const _hoisted_42 = { class: "breadcrumb-item" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "row g-4" }
const _hoisted_45 = {
  key: 3,
  class: "text-center py-10 text-muted"
}
const _hoisted_46 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background":"rgba(0,0,0,.4)"}
}
const _hoisted_47 = { class: "modal-dialog" }
const _hoisted_48 = { class: "modal-content" }
const _hoisted_49 = { class: "modal-header" }
const _hoisted_50 = /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "New Knowledge Base", -1)
const _hoisted_51 = { class: "modal-body" }
const _hoisted_52 = /*#__PURE__*/_createVNode("label", { class: "form-label" }, "Name", -1)
const _hoisted_53 = /*#__PURE__*/_createVNode("label", { class: "form-label" }, "Label (optional)", -1)
const _hoisted_54 = { class: "modal-footer" }
const _hoisted_55 = {
  key: 1,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background":"rgba(0,0,0,.4)"}
}
const _hoisted_56 = { class: "modal-dialog" }
const _hoisted_57 = { class: "modal-content" }
const _hoisted_58 = { class: "modal-header" }
const _hoisted_59 = /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "New Folder", -1)
const _hoisted_60 = { class: "modal-body" }
const _hoisted_61 = { class: "modal-footer" }
const _hoisted_62 = {
  key: 2,
  class: "modal fade show d-block",
  tabindex: "-1",
  style: {"background":"rgba(0,0,0,.4)"}
}
const _hoisted_63 = { class: "modal-dialog" }
const _hoisted_64 = { class: "modal-content" }
const _hoisted_65 = { class: "modal-header" }
const _hoisted_66 = /*#__PURE__*/_createVNode("h5", { class: "modal-title" }, "Add Link", -1)
const _hoisted_67 = { class: "modal-body" }
const _hoisted_68 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_inline_svg = _resolveComponent("inline-svg")
  const _component_router_link = _resolveComponent("router-link")
  const _component_KTFolder = _resolveComponent("KTFolder")
  const _component_KTFile = _resolveComponent("KTFile")

  return (_openBlock(), _createBlock("div", null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 8,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", null, [
      (_ctx.loadError)
        ? (_openBlock(), _createBlock("div", _hoisted_1, _toDisplayString(_ctx.loadError), 1))
        : _createCommentVNode("", true),
      (!_ctx.selectedKb)
        ? (_openBlock(), _createBlock("div", {
            key: 1,
            class: _ctx.embedded ? '' : 'card seq-card mb-5'
          }, [
            (!_ctx.embedded)
              ? (_openBlock(), _createBlock("div", _hoisted_2, [
                  _createVNode("h3", _hoisted_3, [
                    _createVNode("span", _hoisted_4, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Home/Library.svg" })
                    ]),
                    _hoisted_5
                  ]),
                  _createVNode("div", _hoisted_6, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCreateModal = true))
                    }, " New Knowledge Base ")
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: _ctx.embedded ? '' : 'card-body py-3'
            }, [
              (_ctx.embedded)
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showCreateModal = true))
                    }, " New Knowledge Base ")
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_8, [
                _createVNode("span", _hoisted_9, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
                ]),
                _createVNode("div", null, [
                  _hoisted_10,
                  _hoisted_11,
                  _createVNode(_component_router_link, {
                    to: "/settings/team-materials",
                    class: "fw-bold"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }),
                  _hoisted_13
                ])
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("span", _hoisted_15, " Storage: " + _toDisplayString(_ctx.formatStorageBytes(_ctx.storageUsedBytes)) + " / " + _toDisplayString(_ctx.formatStorageBytes(_ctx.storageLimitBytes)), 1)
              ]),
              (!_ctx.knowledgeBases.length)
                ? (_openBlock(), _createBlock("div", _hoisted_16, " No knowledge bases yet. Create one to add documents and links for AI replies. "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.groupedKnowledgeBases, (group) => {
                return (_openBlock(), _createBlock("div", {
                  key: group.label,
                  class: "mb-8"
                }, [
                  _createVNode("h5", _hoisted_17, _toDisplayString(group.label), 1),
                  _createVNode("div", _hoisted_18, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(group.items, (kb) => {
                      return (_openBlock(), _createBlock("div", {
                        key: kb.id,
                        class: "col-12 col-md-6 col-xl-4"
                      }, [
                        _createVNode("div", _hoisted_19, [
                          _createVNode("div", _hoisted_20, [
                            _createVNode("div", _hoisted_21, [
                              _createVNode("h4", _hoisted_22, _toDisplayString(kb.name), 1),
                              (kb.shared && !kb.owned)
                                ? (_openBlock(), _createBlock("span", _hoisted_23, "Shared"))
                                : (kb.sharedToDownline)
                                  ? (_openBlock(), _createBlock("span", _hoisted_24, "Shared with downline"))
                                  : _createCommentVNode("", true)
                            ]),
                            (kb.label)
                              ? (_openBlock(), _createBlock("p", _hoisted_25, _toDisplayString(kb.label), 1))
                              : _createCommentVNode("", true),
                            _createVNode("div", _hoisted_26, [
                              _createVNode("button", {
                                type: "button",
                                class: "btn btn-sm btn-primary",
                                onClick: ($event: any) => (_ctx.openKnowledgeBase(kb))
                              }, " Open ", 8, ["onClick"]),
                              (kb.owned)
                                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                    _createVNode("button", {
                                      type: "button",
                                      class: "btn btn-sm btn-light-primary",
                                      onClick: ($event: any) => (_ctx.promptEditKb(kb))
                                    }, " Edit ", 8, ["onClick"]),
                                    (_ctx.canShare)
                                      ? (_openBlock(), _createBlock("button", {
                                          key: 0,
                                          type: "button",
                                          class: "btn btn-sm btn-light",
                                          onClick: ($event: any) => (_ctx.toggleShare(kb))
                                        }, _toDisplayString(kb.sharedToDownline ? "Unshare" : "Share"), 9, ["onClick"]))
                                      : _createCommentVNode("", true),
                                    _createVNode("button", {
                                      type: "button",
                                      class: "btn btn-sm btn-light-danger",
                                      onClick: ($event: any) => (_ctx.confirmDeleteKb(kb))
                                    }, " Delete ", 8, ["onClick"])
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ], 2)
          ], 2))
        : (_openBlock(), _createBlock("div", {
            key: 2,
            class: _ctx.embedded ? '' : 'card seq-card mb-5'
          }, [
            (!_ctx.embedded)
              ? (_openBlock(), _createBlock("div", _hoisted_27, [
                  _createVNode("div", _hoisted_28, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-light me-3",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeKnowledgeBase && _ctx.closeKnowledgeBase(...args)))
                    }, [
                      _hoisted_29
                    ]),
                    _createVNode("span", _hoisted_30, _toDisplayString(_ctx.selectedKb.name), 1),
                    (_ctx.selectedKb.label)
                      ? (_openBlock(), _createBlock("span", _hoisted_31, _toDisplayString(_ctx.selectedKb.label), 1))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: _ctx.embedded ? '' : 'card-body py-3'
            }, [
              (_ctx.embedded)
                ? (_openBlock(), _createBlock("div", _hoisted_32, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-light",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeKnowledgeBase && _ctx.closeKnowledgeBase(...args)))
                    }, [
                      _hoisted_33
                    ]),
                    _createVNode("span", _hoisted_34, _toDisplayString(_ctx.selectedKb.name), 1),
                    (_ctx.selectedKb.label)
                      ? (_openBlock(), _createBlock("span", _hoisted_35, _toDisplayString(_ctx.selectedKb.label), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.selectedKb.owned)
                ? (_openBlock(), _createBlock("div", _hoisted_36, [
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-light-primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showNewFolderModal = true))
                    }, " New Folder "),
                    _createVNode("label", _hoisted_37, [
                      _hoisted_38,
                      _createVNode("input", {
                        type: "file",
                        class: "d-none",
                        accept: _ctx.KB_FILE_ACCEPT,
                        onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                      }, null, 40, ["accept"])
                    ]),
                    _createVNode("button", {
                      type: "button",
                      class: "btn btn-sm btn-light-primary",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showAddLinkModal = true))
                    }, " Add Link ")
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_39, " This knowledge base is shared with you. You can view items but not edit them. ")),
              _createVNode("nav", _hoisted_40, [
                _createVNode("ol", _hoisted_41, [
                  _createVNode("li", _hoisted_42, [
                    _createVNode("a", {
                      href: "#",
                      onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.openFolder(0)), ["prevent"]))
                    }, _toDisplayString(_ctx.selectedKb.name), 1)
                  ]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.breadcrumbs, (crumb) => {
                    return (_openBlock(), _createBlock("li", {
                      key: crumb.id,
                      class: ["breadcrumb-item", { active: crumb.id === _ctx.currentParentId }]
                    }, [
                      (crumb.id !== _ctx.currentParentId)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            href: "#",
                            onClick: _withModifiers(($event: any) => (_ctx.openFolder(crumb.id)), ["prevent"])
                          }, _toDisplayString(crumb.name), 9, ["onClick"]))
                        : (_openBlock(), _createBlock("span", _hoisted_43, _toDisplayString(crumb.name), 1))
                    ], 2))
                  }), 128))
                ])
              ]),
              _createVNode("div", _hoisted_44, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.folderItems, (item) => {
                  return (_openBlock(), _createBlock(_component_KTFolder, {
                    key: `folder-${item.id}`,
                    "folder-name": item.name,
                    files: 0,
                    "can-manage": _ctx.canManageItems,
                    onOpen: ($event: any) => (_ctx.openFolder(item.id, item.name)),
                    onRename: ($event: any) => (_ctx.promptRename(item)),
                    onDelete: ($event: any) => (_ctx.confirmDeleteItem(item))
                  }, null, 8, ["folder-name", "can-manage", "onOpen", "onRename", "onDelete"]))
                }), 128)),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fileItems, (item) => {
                  return (_openBlock(), _createBlock(_component_KTFile, {
                    key: `file-${item.id}`,
                    "file-title": item.name,
                    "created-at": _ctx.formatDate(item.updatedAt || item.createdAt),
                    "file-type": _ctx.fileIconType(item.fileCategory),
                    "indexing-status": item.indexingStatus,
                    "can-manage": _ctx.canManageItems,
                    onOpen: ($event: any) => (_ctx.openItem(item)),
                    onRename: ($event: any) => (_ctx.promptRename(item)),
                    onDelete: ($event: any) => (_ctx.confirmDeleteItem(item))
                  }, null, 8, ["file-title", "created-at", "file-type", "indexing-status", "can-manage", "onOpen", "onRename", "onDelete"]))
                }), 128))
              ]),
              (!_ctx.folderItems.length && !_ctx.fileItems.length)
                ? (_openBlock(), _createBlock("div", _hoisted_45, " This folder is empty. "))
                : _createCommentVNode("", true)
            ], 2)
          ], 2))
    ], 512), [
      [_vShow, !_ctx.loading]
    ]),
    (_ctx.showCreateModal)
      ? (_openBlock(), _createBlock("div", _hoisted_46, [
          _createVNode("div", _hoisted_47, [
            _createVNode("div", _hoisted_48, [
              _createVNode("div", _hoisted_49, [
                _hoisted_50,
                _createVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.showCreateModal = false))
                })
              ]),
              _createVNode("div", _hoisted_51, [
                _hoisted_52,
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.newKbName = $event)),
                  type: "text",
                  class: "form-control mb-3"
                }, null, 512), [
                  [_vModelText, _ctx.newKbName]
                ]),
                _hoisted_53,
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.newKbLabel = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "e.g. Product, Onboarding"
                }, null, 512), [
                  [_vModelText, _ctx.newKbLabel]
                ])
              ]),
              _createVNode("div", _hoisted_54, [
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showCreateModal = false))
                }, "Cancel"),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.createKb && _ctx.createKb(...args)))
                }, "Create")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showNewFolderModal)
      ? (_openBlock(), _createBlock("div", _hoisted_55, [
          _createVNode("div", _hoisted_56, [
            _createVNode("div", _hoisted_57, [
              _createVNode("div", _hoisted_58, [
                _hoisted_59,
                _createVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showNewFolderModal = false))
                })
              ]),
              _createVNode("div", _hoisted_60, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.newFolderName = $event)),
                  type: "text",
                  class: "form-control",
                  placeholder: "Folder name"
                }, null, 512), [
                  [_vModelText, _ctx.newFolderName]
                ])
              ]),
              _createVNode("div", _hoisted_61, [
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showNewFolderModal = false))
                }, "Cancel"),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.createFolder && _ctx.createFolder(...args)))
                }, "Create")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showAddLinkModal)
      ? (_openBlock(), _createBlock("div", _hoisted_62, [
          _createVNode("div", _hoisted_63, [
            _createVNode("div", _hoisted_64, [
              _createVNode("div", _hoisted_65, [
                _hoisted_66,
                _createVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.showAddLinkModal = false))
                })
              ]),
              _createVNode("div", _hoisted_67, [
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.linkName = $event)),
                  type: "text",
                  class: "form-control mb-3",
                  placeholder: "Link name"
                }, null, 512), [
                  [_vModelText, _ctx.linkName]
                ]),
                _withDirectives(_createVNode("input", {
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.linkUrl = $event)),
                  type: "url",
                  class: "form-control",
                  placeholder: "https://..."
                }, null, 512), [
                  [_vModelText, _ctx.linkUrl]
                ])
              ]),
              _createVNode("div", _hoisted_68, [
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-light",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showAddLinkModal = false))
                }, "Cancel"),
                _createVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.addLink && _ctx.addLink(...args)))
                }, "Add")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}